module.exports = __webpack_public_path__ + "img/caret-right.3a31df0d.svg";